export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
vm(require("commerce-subscription-cards-lib/lang/en.lyaml"));
vm(require("commerce-billing-lib/lang/en.lyaml"));
vm(require("crm-activity-creator-widgets/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("crm-cards-sdk/lang/en.lyaml"));
at({ "en": { "crmCards": { "errorMessage": "There was a problem loading your data. Please refresh the page to try again.", "labelBadge": { "beta": "Beta", "new": "New" }, "locationSettingsButton": "Customize" } } });
};